/**
 * This code was AUTOGENERATED using the codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  fixDecoderSize,
  fixEncoderSize,
  getBytesDecoder,
  getBytesEncoder,
  type Codec,
  type Decoder,
  type Encoder,
  type ReadonlyUint8Array,
} from '@solana/kit';

/** Authenticated encryption containing an account balance. */
export type DecryptableBalance = ReadonlyUint8Array;

export type DecryptableBalanceArgs = DecryptableBalance;

export function getDecryptableBalanceEncoder(): Encoder<DecryptableBalanceArgs> {
  return fixEncoderSize(getBytesEncoder(), 36);
}

export function getDecryptableBalanceDecoder(): Decoder<DecryptableBalance> {
  return fixDecoderSize(getBytesDecoder(), 36);
}

export function getDecryptableBalanceCodec(): Codec<
  DecryptableBalanceArgs,
  DecryptableBalance
> {
  return combineCodec(
    getDecryptableBalanceEncoder(),
    getDecryptableBalanceDecoder()
  );
}
